<template>
  <Dialog
    v-model:visible="isVisible"
    :modal="true"
    :closable="true"
    :dismissable-mask="true"
    class="col-12"
    @show="onShow"
  >
    <template #header>
      <div class="content-header">
        <h3>{{ $t('dialog.detailbarcode.title') }}</h3>
      </div>
    </template>
    <div class="col">
      <ControlTableComponent
        v-model:sortField="lineIdFilter.pageable.sortField"
        v-model:sortOrder="lineIdFilter.pageable.sortOrder"
        v-model:filters="lineIdFilter.filters"
        v-model:rows="lineIdFilter.pageable.size"
        paginator
        paginator-position="both"
        :value="lines"
        :total-records="totalLineIdCount"
        @sort="getLineIds"
        @filter="getLineIds"
        @page="onLineIdPageChange($event)"
      />
    </div>
  </Dialog>
</template>

<script>
import Dialog from "primevue/dialog";
import {reactive} from "vue";
import useLineIdFilter from "@/composables/filters/useLineIdFilter";
import {FilterMatchMode} from "primevue/api";
import ControlTableComponent from "@/components/control/ControlTableComponent.vue";

export default {
  name: 'BarcodeRangeDetailDialog',
  components: {
    ControlTableComponent,
    Dialog
  },
  props: {
    barcode: {
      type: Object,
      required: true
    },
    visible: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update:visible', 'edit'],
  setup() {
    const lineIdFilter = reactive(useLineIdFilter());
    return {
      lineIdFilter
    }
  },
  data() {
    return {
      lines: [],
      totalLineIdCount: 0,
      isLoading: false,
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      }
    }
  },
  methods: {
    onShow() {
      this.setBaseFilter();
      this.getLineIds();
    },
    setBaseFilter() {
      this.lineIdFilter.filters.barcodeRangeId.value = this.barcode.id;
      this.lineIdFilter.filters.barcodeRangeId.matchMode = FilterMatchMode.EQUALS;
      this.lineIdFilter.filters.stakeholder.value = this.barcode.stakeholder.id;
    },
    async getLineIds() {
      this.isLoading = true
      try {
        const result = await this.$lineIdService.fetchLinesPagingAndSorting(this.lineIdFilter.getQueryParams());
        this.lines = result.content;
        this.totalLineIdCount = result.totalElements;
      } catch (e) {
        console.error(e);
        this.$emitter.emit('toast', {severity: 'error', message: 'error.global'});
      } finally {
        this.isLoading = false
      }
    },
    onLineIdPageChange(event) {
      this.lineIdFilter.pageable.page = event.page;
      this.getLineIds();
    },
    close() {
      this.isVisible = false;
    }
  }
}
</script>
